// extracted by mini-css-extract-plugin
module.exports = {"image":"QA-z","loaded":"RA-z","placeholder":"SA-z"};